import view from './banner'
export default view
